import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LS } from 'src/app/helpers/localStorage.enum';
import { ChatService } from 'src/app/services/chat/chat.service';

@Component({
  selector: 'app-edit-discussion',
  templateUrl: './edit-discussion.component.html',
  styleUrls: ['./edit-discussion.component.sass'],
})
export class EditDiscussionComponent implements OnInit {
  thread;
  chats: Array<any>;
  currentUser;
  chatForm: FormGroup;
  activatedRouteSub;

  constructor(
    private formBuilder: FormBuilder,
    private chatService: ChatService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private _t: TranslateService
  ) {}

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem(LS.currentUser));
    this.activatedRouteSub = this.activatedRoute.params.subscribe(({ id }) => {
      this.chatService.findOne(id).subscribe((res) => {
        this.thread = res
        this.chats = res.chats;
      });
    });
    this.chatForm = this.formBuilder.group({
      sender_id: this.currentUser.id,
      message: '',
    });
  }

  sendChat() {
    const message = this.chatForm.get('message').value.trim();
    if (message.length > 1) {
      this.chatService.create({chat_thread: this.thread.id, content: message}).subscribe(res => {
        const chat = {
          content: res.content,
          sender: {
            id: res.sender,
            username: this.currentUser.username,
          },
        };
        this.chatForm.controls['message'].reset();
        this.chats.push(chat);
      }, ({error}) => {
        const msg = error.message.reduce((results, u) => (results += u + ', ', results), '').slice(0, -2)
        this.toastr.error(this._t.instant(msg), this._t.instant('Error'));
      })
    }
  }
}
